import React from 'react';
import { Star, StarHalf } from 'lucide-react';

const Ratings = ({ ratings }) => {
  const renderStars = () => {
    const stars = [];
    
    // Calculate full stars
    const fullStars = Math.floor(ratings);
    
    // Add full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={`full-${i}`} className="text-[#EDBB0E]">
          <Star size={18} />
        </span>
      );
    }
    
    // Check if we need a half star
    if (ratings % 1 >= 0.5) {
      stars.push(
        <span key="half" className="text-[#EDBB0E]">
          <StarHalf size={18} />
        </span>
      );
    }
    
    return stars;
  };

     return (
    <div className="flex items-center space-x-1">
      {renderStars()}
    </div>
  );
};

export default Ratings;